import React from "react";
import { Form } from "@redriver/cinnamon";
import { getInvoiceTypes } from "./actions";

export const InvoiceTypesDropdown = (props) => (
  <Form.Dropdown {...props} lookupAction={getInvoiceTypes} />
);

export default InvoiceTypesDropdown;
